<template>
  <v-row>
    <v-col class="text-center kbGrayText--text" cols="12" >
      <h3>{{ $t('general.selectResponsible') }}</h3>
    </v-col>

    <v-col class="pa-2 d-flex justify-center" cols="12">
      <v-autocomplete
        class="pa-5"
        color="kbDarkBlueText"
        :items="administrators"
        item-text="fullName"
        item-value="userId"
        :label="$t('general.pickAResponsible')"
        outlined
        :search-input="search"
        style="max-width: 500px"
        :value="value"
        @change="$emit('input', value)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['administrators'])
  },
  created () {
    this.$store.commit('SET_PAGINATION_USERS_COMPANY', {
      page: 1,
      itemsPerPage: 300,
      sortBy: [],
      sortDesc: []
    })
    this.getAdministrators()
  },
  data () {
    return {
      search: ''
    }
  },
  methods: {
    async getAdministrators () {
      await this.$store.dispatch('getAdministrators')
    }
  },
  props: {
    value: {
      type: String
    }
  }
}
</script>
